import React, { useContext } from "react";
import UserProgressContext from "../../userProgressContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVolumeHigh, faVolumeXmark } from "@fortawesome/free-solid-svg-icons";

const BackgroundSoundToggle = () => {
  const { audioMuted, setAudioMuted } = useContext(UserProgressContext);

  const toggleMute = () => {
    setAudioMuted(!audioMuted);
  };
  return (
    <button
      onClick={toggleMute}
      title={!audioMuted ? "Turn off the sound" : "Play the sound"}
    >
      <FontAwesomeIcon icon={!audioMuted ? faVolumeHigh : faVolumeXmark} />
    </button>
  );
};

export default BackgroundSoundToggle;
